import React from 'react'
import PropTypes from 'prop-types'
import { StickyContainer, Sticky } from 'react-sticky'

import Slideshow from '../Slideshow/SlideTest'
import Page from '../Page'

import { Wrapper, Box, Text, Top, Tag } from './styles.css'

class HomeWrapperEl extends React.Component {
  shouldComponentUpdate(prevProps) {
    return true
    if (prevProps !== this.props) {
      if (prevProps.collageArt && prevProps.collageArt.length !== this.props.collageArt.length) {
        return true
      }
      return false
    }
    return false
  }
  render() {
    const { collageArt, studentSlideArt, siteName, children } = this.props
    return (
      <Page siteName={siteName}>
        <div style={{ minHeight: '33vh' }} />

        <Wrapper width="full">
          <Box shadow width="full">
            <Slideshow
              collection={studentSlideArt}
              ready={studentSlideArt && studentSlideArt.length > 0}
            />
          </Box>
        </Wrapper>

        <div style={{ minHeight: '25vh' }} />

        <Wrapper>
          <StickyContainer>
            <Box shadow border align="flex-start">
              <Sticky>
                {({ style }) => (
                  <div style={style}>
                    <Top>Spring / Summer 2019</Top>
                  </div>
                )}
              </Sticky>
              <Tag>Meet the next generation of creative thinkers.</Tag>
              <Text>
                <bold>MICA GRAD SHOW 2019</bold> showcases the culminating work of more than 180 of
                MICA&apos;s graduate students from the College&apos;s internationally renowned
                programs through ground-breaking exhibitions, presentations, public programs and
                student-curated installations throughout Baltimore City.
                <br />
                <br />
                Join us for a season of innovative and inspiring events and exhibitions featuring
                the next generation of creative thinkers — artists, designers, filmmakers, educators
                and curators — as they demonstrate the power and possibility of contemporary art and
                design.
              </Text>
            </Box>
          </StickyContainer>
        </Wrapper>

        <div style={{ minHeight: '25vh' }} />

        <Wrapper>{children}</Wrapper>

        <div style={{ minHeight: '33vh' }} />
      </Page>
    )
  }
}

const artPropType = PropTypes.shape({
  id: PropTypes.string,
  image: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
  }),
  title: PropTypes.string,
})

HomeWrapperEl.propTypes = {
  collageArt: PropTypes.arrayOf(artPropType),
  studentSlideArt: PropTypes.arrayOf(PropTypes.object),
  siteName: PropTypes.string,
  children: PropTypes.node,
}
HomeWrapperEl.defaultProps = {
  collageArt: null,
  studentSlideArt: null,
  siteName: null,
  children: null,
}

export default HomeWrapperEl
